// @givmo/employer-module — WHO MAY ADD FUNDS, AND WHO MAY SET THE DEFAULT CARD (EP-SUITE7, D-EP-50).
//
// Adding funds (`company_wallet:deposit` — the deposit and its quote) and setting the company's default
// payment method (`company:edit_default_payment_method`, split out of `company:edit`) were the company-
// wide Owner's alone — the portal's "Owner", the console's Global Admin — so every surface gated them on
// the base role. Since EP-SUITE7 both sit in the Donations (employer) module's Owner catalog: a Donations
// Owner who is not a Global Admin holds them by default, and a Global Admin can take either away from an
// admin (Customize). So the gate is the base-role Owner — keeping its deliberate fail-OPEN while the role
// read is in flight or has failed, since the server checks every write — OR the standing read's
// effective set holding the act's own string.
//
// The Dashboard's Add funds, the competition publish dialog's shortfall, the console's Wallet and the
// portal's Payment Methods all decide with this, so a door one of them shows leads to a control on the
// page it opens.

import { ROLE_OWNER } from '../admins/admins-roles';

/** The deposit's own string (`CompanyService.deposit_funds_company` / `quote_company_deposit`). */
export const DEPOSIT_PERMISSION = 'company_wallet:deposit';

/** The default-card writer's string (`CompanyService.update_company_default_payment_method`). */
export const DEFAULT_PAYMENT_METHOD_PERMISSION = 'company:edit_default_payment_method';

/** One read of `GET /admin/company/me`, as a host holds it. */
export interface FundingStanding {
  /** Whether the read SETTLED successfully. While it has not, the answer is yes (fail-OPEN). */
  settled: boolean;
  /** The caller's base role (`admin_company_role`). */
  role: string | null | undefined;
  /** The caller's effective permission set — `null` or absent when the read carries none. */
  permissions: readonly string[] | null | undefined;
}

function mayAct(standing: FundingStanding, permission: string): boolean {
  if (!standing.settled) return true;
  if (standing.role === ROLE_OWNER) return true;
  return Array.isArray(standing.permissions) && standing.permissions.includes(permission);
}

/** Whether this person may add funds to the company wallet. */
export function mayAddFunds(standing: FundingStanding): boolean {
  return mayAct(standing, DEPOSIT_PERMISSION);
}

/** Whether this person may choose the company's default card. */
export function maySetDefaultCard(standing: FundingStanding): boolean {
  return mayAct(standing, DEFAULT_PAYMENT_METHOD_PERMISSION);
}
